import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=9a89e58a&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=9a89e58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a89e58a",
  null
  
)

export default component.exports